import React from 'react';
import { WithSearch } from '@elastic/react-search-ui';
import CustomPagination from './CustomPagination';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => (typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false));
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);
  return isMobile;
}
/**
 Integrates with react-search-ui and switches pagination layout for mobile/desktop.
 */
export default function CustomPaginationView({
  pagingContainer,
}: {
  pagingContainer: string;
}) {
  const isMobile = useIsMobile(768);
  return (
    <WithSearch
      mapContextToProps={({ current, totalPages, setCurrent }) => ({
        current: current || 1,
        totalPages: totalPages || 1,
        setCurrent,
      })}
    >
      {(props) => (
        <CustomPagination
          {...props}
          pagingContainer={pagingContainer}
          isMobile={isMobile}
          visiblePages={4} // desktop window size
        />
      )}
    </WithSearch>
  );
}
